// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__31cla","search":"Settings_search__L6Ybh","filter":"Settings_filter__ES_Nq"};